export default __webpack_public_path__ + "static/media/56.a5df1dff.jpeg";